import React from 'react';
import { FuelTypography, FuelSign } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import * as Styled from './StepSummaryStyles';

interface StepSummaryProps {
  iconName: string;
  title: string;
  description: string;
  isMobile: boolean;
}

function StepSummary({
  iconName,
  title,
  description,
  isMobile,
}: StepSummaryProps) {
  return (
    <FuelFlex defaultProps={{ gap: 'km4' }}>
      <FuelSign
        icon={iconName}
        size="small"
        color="blue"
        colorIntensity="weak"
      />
      <Styled.Section>
        <FuelTypography
          weight="bold"
          size={isMobile ? 'body-md' : 'body-lg'}
          color="neutral-strong"
        >
          {title}
        </FuelTypography>
        <FuelTypography weight="medium" size="body-sm" color="neutral-default">
          {description}
        </FuelTypography>
      </Styled.Section>
    </FuelFlex>
  );
}

export default StepSummary;
